import { Directive, input } from '@angular/core';
import { downloadFile } from '@reconcept-platform/shared/util';

@Directive({
  selector: '[download-link]',
  host: {
    '(click)': 'clickDownloadLink($event)',
  },
})
export class DownloadLinkDirective {
  href = input.required<string>();

  clickDownloadLink(event: MouseEvent) {
    // don't fire the href
    event.preventDefault();
    event.stopPropagation();

    downloadFile(this.href());
  }
}
